/**
 * Capitalizes the first letter of a string.
 *
 * @param str - The string to capitalize
 * @returns The string with the first letter capitalized
 *
 * @example
 * capitalize('hello') // 'Hello'
 * capitalize('world') // 'World'
 * capitalize('') // ''
 */
export const capitalize = (str: string): string => {
	if (!str) return str;
	return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Uppercase the first letter of a string.
 *
 * @param str - The string to uppercase the first letter of
 * @returns The string with the first letter uppercase
 *
 * @example
 * ucasefirst('hello') // 'Hello'
 * ucasefirst('world') // 'World'
 * ucasefirst('WORLD') // 'World'
 * ucasefirst('') // ''
 */
export const ucasefirst = (str: string): string => {
	if (!str) return str;
	return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
